import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box, Card, CardContent, Grid, Skeleton, Stack, Button } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useParams } from 'react-router-dom';
import { useAuth } from 'hooks';
import API from 'services/AxiosConfig';
import Analytic from '../../Analytic';
import { Typography, useMediaQuery } from '@mui/material';
import Preloader from '../../Preloader';
import { Add } from 'iconsax-react';
import {
  CSVExport,
  DebouncedInput,
  HeaderSort,
  RowSelection,
  SelectColumnSorting,
  TablePagination,
} from '../../react-table';
import EditIcon from '@mui/icons-material/Edit';
import ProgressModalContent from './ProgressModalContent';
import { ProgressCards } from './ProgressCards';
import { useTheme } from '@mui/material/styles';
const StageManagement = () => {
  const { user } = useAuth();
  const userId = useParams();
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [progressData, setProgressData] = useState<any>([]);
  const [stageUrl, setStageUrl] = useState('/applicants/progress');
  const [editData, setEditData] = useState({});
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  let id = userId.id;
  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
    if (newValue === 0) {
      setStageUrl('/applicants/progress');
      fetchData('/applicants/progress');
    } else {
      setStageUrl('/prospects/progress');
      fetchData('/prospects/progress');
      id = userId.prospectId;
    }
  };
  const fetchData = (stageUrl: any = '/applicants/progress', parentRefresh = false) => {
    setLoading(true);
    API.get(stageUrl)
      .then((rsp: any) => {
        const data = rsp.data.data;
        setProgressData(data?.progress);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData('/applicants/progress');
  }, []);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleEditOpen = (name: any, item: any, idx: any) => {
    setEditData({ cardName: name, items: item, idx: idx });
    setOpen(true);
  };
  const handleCloseModal = () => {
    setOpen(false);
    fetchData(value === 0 ? '/applicants/progress' : '/prospects/progress');
  };
  return (
    <>
      <Analytic />
      <br />

      <div className="heading" >
        <Typography variant="h1">Stage Management</Typography>
        {isMobile && (
          <Button
            variant="contained"
            color="primary"
            className="common-button"
            size="small"
            onClick={handleOpen}
          >
            Add Stage
          </Button>
        )}
      </div>
      <br />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className="tabs">
        <Tabs variant="fullWidth" value={value} onChange={handleChange} aria-label="profile tabs">
          <Tab
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              textTransform: 'capitalize',
            }}
            label="Applicant"
            className={value === 0 ? 'tabs one' : 'tabs two'}
          />
          <Tab
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              textTransform: 'capitalize',
            }}
            label="Prospects"
            className={value === 1 ? 'tabs one' : 'tabs two'}
          />
        </Tabs>
      </Box>
      <Stack
        direction="row"
        className="table-searching"
        spacing={2}
        alignItems="center"
        justifyContent="end"
        sx={{ padding: 3 }}>
        <Stack direction="row" alignItems="center" spacing={2}>{!isMobile && (
          <Button variant="contained" startIcon={<Add />} onClick={handleOpen} size="large">

            Add Stage
          </Button>
        )}
        </Stack>
      </Stack>
      {open ? (
        <ProgressModalContent
          open={open}
          closeMe={handleCloseModal}
          id={id}
          fetchData={fetchData}
          URLPATH={stageUrl}
          type={value}></ProgressModalContent>
      ) : null}
      {loading === true ? (
        <>
          <Grid container spacing={2} sx={{ padding: 1 }}>
            {[...Array(4)].map((_, index) => (
              <Grid item xs={12} md={3} key={index} mb={3}>
                <Card>
                  <CardContent className="card-content">
                    <Skeleton variant="text" width="80%" />
                    <Grid
                      container
                      spacing={3}
                      style={{ backgroundColor: '#fff', padding: '12px', borderRadius: '12px' }}>
                      <Grid item xs={12} className="date-box" key={index}>
                        <Skeleton variant="rectangular" height={56} />
                      </Grid>
                      <Grid item xs={12} className="date-box" key={index}>
                        <Skeleton variant="rectangular" height={56} />
                      </Grid>
                      <Grid item xs={12} className="date-box" key={index}>
                        <Skeleton variant="rectangular" height={56} />
                      </Grid>
                      <Grid item xs={12} className="date-box" key={index}>
                        <Skeleton variant="rectangular" height={56} />
                      </Grid>
                      <Grid item xs={12} className="date-box" key={index}>
                        <Skeleton variant="rectangular" height={56} />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      ) : (
        <Grid container spacing={2} sx={{ padding: 1 }}>
          {progressData?.map((val: any, idx: number) => (
            <ProgressCards
              val={val}
              idx={idx}
              id={id}
              fetchData={fetchData}
              stageUrl={stageUrl}
              type={value}></ProgressCards>
          ))}
        </Grid>
      )}
    </>
  );
};

export default StageManagement;
